import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class AppConfigService {
  numberOfNotificationSubject = new Subject<number>();
  _numberOfNotification = 0;
  set numberOfNotification(_numberOfNotification: number) {
    this._numberOfNotification = _numberOfNotification;
    this.numberOfNotificationSubject.next(this._numberOfNotification);
  }
  get numberOfNotification(): number {
    return this._numberOfNotification;
  }

  menuSubject = new Subject<any>();
  _menus: any[];
	set menus(_menus: any[]) {
    this._menus = _menus;
    this.menuSubject.next(this._menus);
  }
  get menus(): any[] {
    return this._menus;
  }

  constructor(
    private http: HttpClient
	) {
	}

  loadAppConfig(): any {
    return new Promise<void>((resolve) => {
      this.http.get('/assets/json/environment.json').subscribe((data: any) => {
        if (data) {
          Object.keys(data).forEach((field: string) => {
            if (data[field]) {
              environment[field] = data[field];
            }
          });

          const isKeycloakUsed: string = (environment['isKeycloakUsed'] === "true") ? 'true' : 'false';
          localStorage.setItem("isKeycloakUsed", isKeycloakUsed);

          if (environment.profile === 'db-inc' || environment.profile === 'vecta') {
            const favicon = document.getElementById('appFavicon') as HTMLLinkElement;
            if (favicon) {
              favicon.href = `assets/images/logo/${environment.profile}/favicon.png`;
            }
          }
        }
        resolve();
      });
    });
  }
}
